export default {
    // * * Move crm permission to this file
    CRM_OPPORTUNITY_WRITE: 'crm.opportunity:write',
    CRM_OPPORTUNITY_TRANSFER_TO_LOT: 'crm.opportunity:transfer_to_lot',
};
